import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project, index = 0 }) => {
  const projectId = project?.id || project?._id;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link to={`/projects/${projectId}`} className="group block">
        <div className="card-premium overflow-hidden">
          {/* Image */}
          <div className="relative h-72 overflow-hidden">
            <img
              src={project.image}
              alt={project.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-800 ease-luxury"
            />

            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/40 transition-all duration-500 ease-luxury flex items-center justify-center">
              <span className="translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-luxury text-xs font-sans font-medium uppercase tracking-widest-plus text-white border border-white/40 px-6 py-2.5">
                View Project
              </span>
            </div>

            {/* Status Badge */}
            <div className="absolute top-4 left-4">
              <span className="flex items-center gap-2 px-3 py-1.5 text-[10px] font-sans font-medium uppercase tracking-widest-plus bg-charcoal/70 backdrop-blur-sm text-white border-l-2 border-gold">
                <span className={`w-1.5 h-1.5 rounded-full ${
                  project.status === 'Completed'
                    ? 'bg-emerald-400'
                    : project.status === 'Ongoing'
                    ? 'bg-gold'
                    : 'bg-white/60'
                }`} />
                {project.status}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="flex items-center text-gold text-xs font-sans uppercase tracking-widest-plus mb-3">
              <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              {project.location}
            </div>
            <h3 className="text-xl font-serif font-semibold text-charcoal group-hover:text-gold transition-colors duration-300 mb-2">
              {project.name}
            </h3>
            <p className="text-charcoal/50 font-sans text-sm leading-relaxed mb-4">
              {project.description}
            </p>
            <div className="flex items-center justify-between pt-4 border-t border-cream-200">
              <span className="text-[10px] font-sans text-charcoal/40 uppercase tracking-widest-plus">{project.type}</span>
              <span className="text-gold text-xs font-sans font-medium group-hover:translate-x-1 transition-transform duration-300 inline-flex items-center">
                Details
                <svg className="w-3.5 h-3.5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </div>
          </div>

          {/* Bottom gold line that grows on hover */}
          <div className="h-0.5 bg-cream-100">
            <div className="h-full bg-gold w-0 group-hover:w-full transition-all duration-700 ease-luxury" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProjectCard;
